import { useCallback } from 'react'

import { Button, SkeletonBox } from '@circlefin/components'
import { useModal } from '@circlefin/modal-router'
import { usePermission } from '@circlefin/permissions/react'
import { ADDRESS_BOOK_REMOVAL } from '@services/permissions'
import { routes } from '@services/sections/modal/routes'
import classNames from 'classnames'
import useTranslation from 'next-translate/useTranslation'

export interface RemoveAddressProps {
  /**
   * Address Id.
   */
  addressId: string
  /**
   * Address nickname.
   */
  nickname: string
  /**
   * Custom style.
   */
  className?: string
}

export const RemoveAddress: React.FC<RemoveAddressProps> = ({
  addressId,
  nickname,
  className,
}) => {
  const { t } = useTranslation('address-book/containers')

  const { router } = useModal()
  const [{ Authorized }, { loading }] = usePermission(ADDRESS_BOOK_REMOVAL)

  const handleClickRemoveAddress = useCallback(() => {
    router.push({
      pathname: routes.account.addressBook.removeAddress.confirmation,
      query: {
        addressId,
        nickname,
      },
    })
  }, [router, addressId, nickname])

  return (
    <SkeletonBox className="h-11 w-full" loading={loading}>
      <Authorized>
        <div
          className={classNames('flex justify-between', className)}
          data-testid="remove-address-cta"
        >
          <div className="flex flex-col">
            <p className="text-neutral-strong">
              {t('wallet-information.remove-address.label')}
            </p>
            <p className="type-body-sm">
              {t('wallet-information.remove-address.description')}
            </p>
          </div>
          <Button
            intent="destructive"
            onClick={handleClickRemoveAddress}
            variant="text"
          >
            {t('wallet-information.remove-address.cta')}
          </Button>
        </div>
      </Authorized>
    </SkeletonBox>
  )
}
